import {
	getViemClients,
} from "@bracket/contractor-next";

import {
	assertAllowance,
} from "@bracket/contractor-next/erc20";

import {
	getTokenDefinition,
	getContractWithABI,
	isBlockHash,
	isAddress,
	type BlockHash,
	type Address,
	type ValidChainId,
} from "@bracket/chainography";

import type { Config } from "@wagmi/core";

export declare type BracketVaultDepositProps = {
	vault: Address;
	amount: number | bigint;
	chainId?: ValidChainId;
	config?: Config;
	timeout?: number;
};

/**
 * 
 * @param {Address} vault the vault address for this transaction
 * @param {number|bigint} amount the amount of brktETH being deposited
 * @returns 
 */
export const deposit = async ({
	vault,
	amount,
	config,
	chainId = 1,
	timeout = 30000,
}: BracketVaultDepositProps): Promise<BlockHash> => {
	try {

		if(!isAddress(vault))
			throw new Error("property vault should be a blockchain addresss");

		const address = vault;
		const brkt = getTokenDefinition({ symbol: "BRKTETH", chainId, });
		const [__, abi] = getContractWithABI("BracketVault", chainId);

		const approved = await assertAllowance({ amount, spender: vault, token: brkt, config, });
		if(!approved)
			throw new Error(`failed gaining approval for spending ${amount} ${brkt.symbol} at ${brkt.address}`);

		const [pclient, wclient] = await getViemClients({ chainId, config, });
		const bamount = typeof amount === "bigint" ? amount : BigInt(Math.floor(Number(amount) * (10**18)));

		try {

			const {
				request,
				result,
			} = await pclient.simulateContract({
				address,
				abi,
				functionName: "deposit",
				args: [
					bamount,
				],
				account: wclient.account,
			});

			const hash = await wclient.writeContract(request);

			if(isBlockHash(hash)) {
				await pclient.waitForTransactionReceipt({ hash, timeout });
				return hash;
			}

			throw new Error("expected result to be a bigint");

		} catch (err) {

			throw new Error(`transaction failed  - ${err.message}`);
		}
	} catch (err) {

		throw new Error(`@bracket/chainography/bracket-vault deposit failed - ${err.message}`);
	}
};
